import { Component, OnInit } from '@angular/core';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}

@Component({
  selector: 'app-verify-device',
  templateUrl: './verify-device.component.html',
  providers: [Modal],
  styleUrls: ['./verify-device.component.css']
})
export class VerifyDeviceComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  model: any = {};
  constructor(public dialog: DialogRef<CustomModalContext>, private router: Router, private modal: Modal) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.context = this.dialog.context;
    this.modalData = this.dialog.context.modalData;
  }
  ngOnInit() {}
  continue() {
    this.dialog.context.modalData.otpNumber = this.model.otpNumber;
    this.dialog.context.modalData.next = 'yes';
    this.dialog.close();
  }
  closeClick() {
    this.dialog.context.modalData.next = 'no';
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/verify-device/verify-device.component.ts